import { asScaled } from '../utils';
const tagLayout = {
    fontSize: 12,
    // tag item 间距
    gap: 10,
    // 高度
    height: 24,
    padding: 12,
    borderWidth: 0.5
};
const tagLayoutScaled = asScaled(tagLayout);
export const tag = {
    scaled: tagLayoutScaled,
    unscaled: tagLayout
};
